"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
// Placeholder for the Kevel search banner. A DefaultBanner-like styled
const KevelSearchBanner = ({ title }) => {
    return react_1.default.createElement("div", { "data-testid": "kevel-search-banner-placeholder" }, title);
};
exports.default = KevelSearchBanner;
